'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_LOCALE = 'react-redux-localization/set-locale';

var setLocale = exports.setLocale = function setLocale(locale) {
  return { type: SET_LOCALE, locale: locale };
};

var getLocale = exports.getLocale = function getLocale(state) {
  return state.locale;
};

var localeReducer = exports.localeReducer = function localeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  var action = arguments[1];

  if (action.type === SET_LOCALE) return action.locale;
  return state;
};